import React from 'react';
import {transparentize} from 'polished';
import styled, {css} from 'styled-components';

export interface DotSummaryProps {
  title: string;
  value: string | number;
  dotColor?: string;
  scale?: DotSummaryScale;
}

export enum DotSummaryScale {
  Small = 'small',
  Medium = 'medium',
}

const Title = styled.div`
  font-size: 10px;
  font-weight: 500;
  line-height: 13px;
  letter-spacing: 0.03em;
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};
  text-transform: uppercase;
`;

const Value = styled.div`
  font-weight: 500;
`;

const Wrapper = styled.div<
  DotSummaryProps
>`

display: flex;

&::before {
  content: '';
  display: block;
  position: relative;
  top: 2px;
  border-radius: 50%;

  background-color: ${({dotColor, theme}) => `
      ${dotColor
          ? dotColor
          : transparentize(.8, theme.variables.color)}
  `};

  ${({scale}) => {
    switch (scale) {
      case DotSummaryScale.Small:
        return css`
          width: 6px;
          height: 6px;
          margin-right: 6px;
      `;
      case DotSummaryScale.Medium:
        return css`
          width: 8px;
          height: 8px;
          margin-right: 11px;
      `;
    }
  }}
}

${Value} {
  ${({scale}) => {
    switch (scale) {
      case DotSummaryScale.Small:
        return css`
          font-size: 14px;
          line-height: 18px;

        `;
      case DotSummaryScale.Medium:
        return css`
          font-size: 18px;
          line-height: 23px;
        `;
    }
  }}
}

${Title} {
  ${({scale}) => {
    switch (scale) {
      case DotSummaryScale.Small:
        return css`
          margin-bottom: 2px;
      `;
      case DotSummaryScale.Medium:
        return css`
          margin-bottom: 4px;
      `;
    }
  }
};
`;

/**
 * The component render summary section
 * @param {DotSummaryProps} props
 * @return {React.ReactElement}
 * @constructor
 */
export default function DotSummary(
    props: DotSummaryProps,
)
  : React.ReactElement {
  const {title, value} = props;

  return (
    <Wrapper {...props}>
      <div>
        <Title>{title}</Title>
        <Value>
          {value}
        </Value>
      </div>
    </Wrapper>
  );
};

DotSummary.defaultProps = {
  scale: DotSummaryScale.Medium,
};
